import React, { useRef, useEffect, useContext, useState } from "react";
import Typed from "typed.js";
import ProfileBackground from "./assets/ProfileBackground.svg";
import ResumeFile from "./assets/Resume.pdf";
import { motion } from "framer-motion/dist/framer-motion";
import { headingVariant } from "./PageVariants";
import { NavContext } from "./App";
import { InView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

export default function Home({ pageRef }) {
	const typedElementForSub = useRef(null);
	const typedElementForHeading = useRef(null);
	const setSelectedNav = useContext(NavContext);
	const [isInView, setIsInView] = useState(false);

	useEffect(() => {
		let typedSub = new Typed(typedElementForSub.current, {
			strings: ["HI, THERE! I'M "],
			startDelay: 0,
			typeSpeed: 40,
			showCursor: false,
		});

		let typedHeading = new Typed(typedElementForHeading.current, {
			strings: ["SHIVA PRASAD"],
			startDelay: 800,
			typeSpeed: 80,
			showCursor: true,
		});

		return () => {
			typedSub.destroy();
			typedHeading.destroy();
		};
	}, [isInView]);

	const viewChange = (inView) => {
		setIsInView(inView);
		if (inView) {
			setSelectedNav({ Heading: "HOME" });
		}
	};

	return (
		<InView threshold={0.1} onChange={(inView, entry) => viewChange(inView)}>
			<div
				ref={pageRef}
				className="min-h-screen grid grid-cols-1 md:grid-cols-2 gap-8 justify-between items-center"
			>
				<img
					src={ProfileBackground}
					alt="ProfileBackground"
					className="w-full py-4 md:w-3/4"
				/>
				<div className="w-full py-4">
					<motion.h4
						variants={headingVariant}
						initial="hide"
						animate={isInView ? "show" : "hide"}
						exit="hide"
						className="text-3xl text-green-600 border-l-8 border-green-600 pl-4 pt-6 h-24 tracking-wider"
					>
						<span
							className="text-gray-600 dark:text-gray-400 text-sm"
							ref={typedElementForSub}
						></span>
						<br />
						<span
							className="text-green-600"
							ref={typedElementForHeading}
						></span>
					</motion.h4>
					<motion.p
						initial={{ y: "20px", opacity: 0 }}
						animate={
							isInView ? { y: 0, opacity: 1 } : { y: "20px", opacity: 0 }
						}
						transition={{ duration: 0.28 }}
						className="text-gray-700 my-8 dark:text-gray-200"
					>
						I'm currently a Senior Full Stack Developer at MetLife Group Inc.,
						where I help customize our mobile application to fit new features
						that improves user experience and supports customer needs.
						Advocating for diversity and inclusion is something that's very
						important to me, and hopefully I will always be part of an
						organization that promotes these aspects.
					</motion.p>
					<motion.div
						initial={{ y: "20px", opacity: 0 }}
						animate={
							isInView ? { y: 0, opacity: 1 } : { y: "20px", opacity: 0 }
						}
						transition={{ duration: 0.28 }}
						className="flex justify-between"
					>
						<a
							href={ResumeFile}
							download="Resume.pdf"
							rel="noopener noreferrer"
							className="hover:shadow-xl px-6 py-2 text-white rounded-full bg-green-600 font-semibold text-center"
							aria-label="Download Resume"
						>
							Resum&eacute;
						</a>
						<a
							href="https://github.com/CodeWithSB/"
							target="_blank"
							rel="noopener noreferrer"
							className="hover:text-green-600 text-gray-500"
							aria-label="Github Link"
						>
							<FontAwesomeIcon icon={faGithub} size="2x" />
						</a>
					</motion.div>
				</div>
			</div>
		</InView>
	);
}
